import IcEmpty from './IcEmpty'

export default IcEmpty
